import React from 'react';

const OrganizerCard = ({ organizer, isAwsHelper = false }) => {
  const socialLinks = [];

  if (organizer.linkedin) {
    socialLinks.push(
      <a
        key="linkedin"
        href={organizer.linkedin}
        target="_blank"
        rel="noopener noreferrer"
      >
        LinkedIn
      </a>
    );
  }

  if (organizer.twitter) {
    socialLinks.push(
      <a
        key="twitter"
        href={`https://twitter.com/${organizer.twitter}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Twitter
      </a>
    );
  }

  return (
    <div className={`organizer-card`}>
      <div className="organizer-card-content">
        <div className="organizer-avatar">
          {organizer.avatar.includes('.') ? (
            <img src={`${process.env.PUBLIC_URL}/${organizer.avatar}`} alt={organizer.name} className="avatar-image" />
          ) : (
            organizer.avatar
          )}
        </div>
        <h3>{organizer.name}</h3>
        {(() => {
          const officialRoles = ['User Group Leader', 'AWS Hero', 'Community Manager', 'AWS Community Manager', 'Senior Developer Advocate', 'Senior technical Account Manager'];
          const lines = organizer.role.split('\n');
          const official = lines.filter(l => officialRoles.includes(l));
          const funTitle = lines.filter(l => !officialRoles.includes(l));
          return (
            <>
              <div className="role-container">
                {official.length > 0 && (
                  <p className="role">
                    {official.map((line, index) => (
                      <React.Fragment key={index}>
                        {index > 0 && <br />}
                        {line}
                      </React.Fragment>
                    ))}
                  </p>
                )}
              </div>
              <div className="fun-title-container">
                {funTitle.length > 0 && (
                  <p className="fun-title">
                    {funTitle.flatMap(line => line.split(' & ')).map((part, index) => (
                      <React.Fragment key={index}>
                        {index > 0 && <br />}
                        {part}
                      </React.Fragment>
                    ))}
                  </p>
                )}
              </div>
            </>
          );
        })()}
        <div className="organization-container">
          <p className="organization">
            {organizer.organization.startsWith('AWS User Group') ? (
              <>AWS User Group<br />{organizer.organization.replace('AWS User Group', '').trim()}</>
            ) : organizer.organization}
          </p>
        </div>
        <p className="bio">{organizer.bio}</p>
      </div>

      {socialLinks.length > 0 && (
        <div className="social-links">
          {socialLinks.map((link, index) => (
            <React.Fragment key={index}>
              {index > 0 && ' • '}
              {link}
            </React.Fragment>
          ))}
        </div>
      )}
      {organizer.email && (
        <div className="contact-email">
          <a href={`mailto:${organizer.email}`} className="email-link">
            <span className="email-icon">✉️</span>
            {organizer.email}
          </a>
        </div>
      )}
    </div>
  );
};

export default OrganizerCard;